import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Indianapolis.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Ensure Sustainable Business Growth with Our Mobile App Development
              Indianapolis
            </h2>
            <p>
              Considering the increasing competition in the digital landscape of
              Indianapolis, it is quite challenging for businesses to stand out.
              However, we make it possible by leveraging the latest technologies
              and frameworks with a dedicated focus on iOS and Android app
              development in Indianapolis. From ideation to execution, we
              efficiently craft mobile apps that stand out in the competitive
              digital market on a global level. Our commitment to creating
              intuitive and user-friendly designs, along with innovative app
              development, ensures that businesses can easily engage the vast
              mobile user base. As a result, we ensure that our services cater
              to diverse industry requirements, based on our customized mobile
              solutions for the modern age.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
